<template>
  <div class="container">
    <div v-for="(item, index) in enviromentList" :key="index">
      <div class="title">
        <span style="font-weight: 700">{{ item.abbreviationCategory }}</span>
      </div>
      <div class="top">
        <div class="title">
          <span>1、选择检测性质</span>
        </div>
        <div style="padding: 20px 35px">
          <a-radio-group :options="checkData" v-model="item.natureValue" @change="onChange(value, index)" />
        </div>
      </div>
      <div class="centerTop">
        <div class="title">
          <span>2、选择检测类别</span>
        </div>
      </div>
      <div class="centerBody">
        <a-checkbox-group style="font-size: 24px" v-model="item.categoryValue" :options="item.categoryList" />
        <a-button
          type="primary"
          @click="changeList(index)"
          style="margin-top: 10px; margin-left: 85%"
          :disabled="item.categoryValue.length == 0"
          >获取检测项目</a-button
        >
      </div>
      <div class="centerBottom">
        <div class="title">
          <span>核对检测项目并填写点位数</span>
        </div>
        <div>
          <a-button
            type="primary"
            @click="addList(index)"
            style="margin: 10px; margin-left: 85%"
            :disabled="enviromentList[index].projectList.length <= 0"
            >新增其他检测项目</a-button
          >
        </div>
        <a-table
          :data-source="item.projectList"
          bordered
          :loading="loading"
          :pagination="false"
          :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"
        >
          <a-table-column key="index" title="序号" ellipsis="true" data-index="index" width="100px">
            <template scope="text, record, index">
              {{ index + 1 }}
            </template>
          </a-table-column>
          <a-table-column key="pollutantName" title="检测类别" ellipsis="true" data-index="pollutantName" />
          <a-table-column key="item" title="检测项目" ellipsis="true" data-index="item" />
          <a-table-column key="price" title="单价(元)" ellipsis="true" data-index="price" />
          <a-table-column key="pointNumber" title="*点位数" ellipsis="true" data-index="pointNumber">
            <template slot-scope="text, record, index1">
              <a-input
                v-model="record.pointNumber"
                placeholder="请输入"
                @change="changePrice(text, record, index1, index)"
              ></a-input>
            </template>
          </a-table-column>
          <!-- <a-table-column key="sampleNumber" title="*样品数" ellipsis="true" data-index="sampleNumber">
            <template slot-scope="text, record, index">
              <a-input v-model="record.sampleNumber" placeholder="请输入" @change="changePrice(record, index)"></a-input>
            </template>
          </a-table-column> -->
          <a-table-column key="totalPrice" title="小计" ellipsis="true" data-index="totalPrice">
            <!-- <template slot-scope="text, record">
                               <a-input v-model="record.totalPrice" placeholder="请输入"></a-input>
							</template> -->
          </a-table-column>
          <a-table-column key="standardInfo" title="检测标准" ellipsis="true" data-index="standardInfo" />
          <a-table-column key="limitRange" title="限值范围" ellipsis="true" data-index="limitRange" />
          <a-table-column title="操作" width="100px">
            <template scope="text,record,index1">
              <a @click="deleteProject(record, index1, index)">删除</a>
            </template>
          </a-table-column>
        </a-table>
      </div>
      <div class="centerFooter">
        <a-form-model :model="item.costList" ref="categoriesRef">
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="检测费"
                prop="testExpense"
              >
                <a-input
                  v-model="item.costList.testExpense"
                  @change="changeTotal(index)"
                  :disabled="item.testCharge <= 30000"
                ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="报告编制费"
                prop="reportFabrication"
                :rules="{
                  required: true,
                  message: '请填写报告编制费',
                  trigger: 'change',
                }"
              >
                <a-input
                  v-model="item.costList.reportFabrication"
                  placeholder="请输入"
                  @change="changeTotal(index)"
                ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="专家评审费"
                prop="expertEvaluation"
                :rules="{
                  required: true,
                  message: '请填写专家评审费',
                  trigger: 'change',
                }"
              >
                <a-input
                  v-model="item.costList.expertEvaluation"
                  placeholder="请输入"
                  @change="changeTotal(index)"
                ></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="加急费"
                prop="total"
              >
                <a-input
                  v-model="item.costList.expediteFee"
                  placeholder="请输入"
                  @change="changeTotal(index)"
                ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="合计"
                prop="total"
              >
                <a-input v-model="item.costList.total"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
    </div>
    <addCategory ref="addCategory" @refreshList="refreshList"></addCategory>
  </div>
</template>

<script>
import addCategory from './addCategory.vue'
import {
  getNatureList,
  getRelationPollutantTypeGw,
  getQuoteTestInfo,
  getTestItemInfo,
  removeNormalTestItem,
  saveTestNatureId
} from '@/api/Industry'
import { number } from 'echarts'
export default {
  components: {
    addCategory,
  },
  props: [],
  data() {
    return {
      scroll_y: 300,
      enviromentList: [],
      rowData: '',
      UUID: '',
      checkData: [],
      categoryList: [],
      dataIndex: undefined,
    }
  },
  methods: {
    init(data) {
      this.$nextTick(() => {
        if (data.backType != 1) {
          data.enviromentList.forEach((item) => {
            Object.assign(item, {
              natureValue: undefined,
              projectList: [],
              categoryValue: [],
              categoryList: [],
              costList: {},
            })
          })
        }

        this.enviromentList = JSON.parse(JSON.stringify(data.enviromentList))
        console.log(data.enviromentList, 'enviromentList===============')
        this.rowData = data.rowData
        this.UUID = data.UUID
        this.getNature()
      })
    },
    getNature() {
      getNatureList().then((res) => {
        if (res.code == 200) {
          res.data.list.forEach((item) => {
            Object.assign(item, {
              label: item.natureName,
              value: item.id,
            })
          })
          this.checkData = res.data.list
        }
      })
    },
    onChange(value, index) {
      saveTestNatureId({
        sheetId: this.UUID,
        subId:this.enviromentList[index].id,
        testNatureId: this.enviromentList[index].natureValue
      }).then(res => {
        if(res.code != 200) {
          this.$message.error(res.msg)
        }

      })
      console.log(this.enviromentList[index].natureValue, index, 'value, index================')
      getRelationPollutantTypeGw({
        masterCategoryId: this.enviromentList[index].masterCategoryId,
        natureIds: this.enviromentList[index].natureValue,
      }).then((res) => {
        res.data.list.forEach((item) => {
          Object.assign(item, {
            label: item.pollutantName,
            value: item.id,
          })
        })
        this.enviromentList[index].categoryList = JSON.parse(JSON.stringify(res.data.list)),
          console.log(this.enviromentList, 'this.enviromentList================')
      })
    },
    changeList(index) {
      console.log(this.enviromentList[index], this.rowData, index, '=========================================')
      var data = {
        sheetId: this.UUID,
        subId: this.enviromentList[index].id,
        masterCategoryId: this.enviromentList[index].masterCategoryId,
        natureId: this.enviromentList[index].natureValue,
        list: this.enviromentList[index].categoryValue,
      }
      getQuoteTestInfo(data).then((res) => {
        if (res.code == 200) {
          this.enviromentList[index].projectList = res.data
        }
      })
    },
    //刷新列表
    refreshList() {
      var data = {
        sheetId: this.UUID,
        subId: this.enviromentList[this.dataIndex].id,
        id: this.enviromentList[this.dataIndex].masterCategoryId,
      }
      getTestItemInfo(data).then((res) => {
        if (res.code == 200) {
          this.enviromentList[this.dataIndex].projectList = res.data.quoteTestItemDetailsVOList
        }
      })
    },
    addList(index) {
      this.dataIndex = index
      var data = {
        sheetId: this.UUID,
        subId: this.enviromentList[index].id,
        list: this.enviromentList[index].categoryValue,
        quoteTestItemDetailsVOList: this.enviromentList[index].projectList,
      }
      console.log(data, 'data===================')
      this.$refs.addCategory.init(data)
    },
    changePrice(text, record, index1, index) {
      this.enviromentList[index].projectList[index1].totalPrice = Number(record.pointNumber) * 3 * Number(record.price)
      var num = ''
      this.enviromentList[index].projectList.forEach((item) => {
        if (item.pointNumber) {
          num = Number(num) + Number(item.totalPrice)
        }
      })
      this.enviromentList[index].costList.testExpense = num
      this.enviromentList.splice(1, 0)
      console.log(text, record, index1, index, num, this.enviromentList[index], 'index=========================')
      this.$emit('getcostList', this.enviromentList)
    },
    changeTotal(index) {
      let list = JSON.parse(JSON.stringify(this.enviromentList[index].costList))
      console.log(list, 'list===============')
      var a = list.testExpense
      var b = list.reportFabrication
      var c = list.expertEvaluation
      var e = list.expediteFee
      console.log(a, b, c, e, 'abcabc=======')
      var d = Number(a) + Number(b) + Number(c) + Number(e)
      this.enviromentList[index].costList.total = d
      console.log(this.enviromentList[index].costList, ' this.enviromentList[index].costList=======================')

      this.$emit('getcostList', this.enviromentList)
    },
    // 删除检测项目
    // removeNormalTestItem
    deleteProject(record, index1, index) {
      var _this = this
      this.$confirm({
        title: '是否确认删除?',
        onOk() {
          var array = []
          array.push(record)
          removeNormalTestItem({
            sheetId: _this.UUID,
            subId: _this.enviromentList[index].id,
            quoteTestItemDetailsVOList: array,
          }).then((res) => {
            if (res.code == 200) {
              // 刷新数据
              _this.enviromentList[index].projectList.splice(index1,1)
              _this.$message.success(res.msg)
            } else {
              _this.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          _this.$message.warning('你点击了取消')
        },
        // class: 'test',
      })
      console.log(record, index1, index, 'record,index1,index=============')
    },
  },
}
</script>

<style scoped>
.top {
  border-top: 1px solid rgb(69, 69, 69);
  border-bottom: 1px solid rgb(69, 69, 69);
}
.centerBody {
  padding: 5px 15px 15px;
  border-bottom: 1px solid rgb(69, 69, 69);
}
.centerBottom {
  padding: 20px;
}
</style>